import { WithActualPrice } from '../../../../../../providers/MenuProvider';
import { ProductInterface } from '../../../../../../services/exports/Interfaces';
import useModalRouter from '../../../../common/hooks/useModalRouter';
import { Modals, Tabs } from '../../../../exports/Enums';
import useMobileRouter from '../../../../common/hooks/useMobileRouter';
import { swipeableCssClass } from '../../../../exports/Constants';
import MostPopularProductsCarousel from '../../../../../../components-library/carousel/most-popular-products';

const MostPopularProducts = () => {
  const { openModal, closeModal } = useModalRouter();
  const { tab } = useMobileRouter();

  const onProductClick = (product: WithActualPrice<ProductInterface>): void =>
    openModal({
      id: Modals.MenuItem,
      presentation: {
        initialBreakpoint: 1,
        breakpoints: [0, 1],
        handle: false,
        cssClass: swipeableCssClass,
      },
      props: {
        openModal: true,
        product: product,
        onCloseModal: () => closeModal(Modals.MenuItem),
        showProductAddedToast: tab && tab !== Tabs.Menu,
      },
    });

  return <MostPopularProductsCarousel toggleProduct={onProductClick} />;
};

export default MostPopularProducts;
